import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import { giftCardStore } from './store'
import { KEY } from './constants'

export * from './constants'

export const GiftCardModule: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, giftCardStore)
}
